import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHAT_WIDGET } from '@/data/mockData';
import s from './ChatWidget.module.scss';

// ── 실시간 상담 위젯 (D안 Phase 2-③, 2026-09) ────────────────────────
//   전 페이지 우하단 상시 노출(App 셸). 웹 상담 위젯①.
//   클릭 → 상담 패널: 인사 + 부재 안내 + 빠른 액션(견적문의/카톡/FAQ).
//   ★실제 상담원 연결·챗봇·연락처는 후속(Phase 6). 지금은 구조·동작만.
export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const go = (to?: string) => {
    if (to && to !== '#') { setOpen(false); navigate(to); }
  };

  return (
    <div className={s.wrap}>
      {open && (
        <div className={s.panel} role="dialog" aria-label={CHAT_WIDGET.title}>
          <div className={s.head}>
            <span>{CHAT_WIDGET.title}</span>
            <button className={s.close} onClick={() => setOpen(false)} aria-label="닫기">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" />
              </svg>
            </button>
          </div>
          <div className={s.body}>
            <p className={s.bot}>{CHAT_WIDGET.greeting}</p>
            <p className={s.away}>{CHAT_WIDGET.awayNotice}</p>
            <div className={s.actions}>
              {CHAT_WIDGET.actions.map((a) => (
                <button
                  key={a.label}
                  className={s.action}
                  onClick={() => go(a.to)}
                >
                  {a.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      <button
        className={s.launcher}
        onClick={() => navigate('/support/consult')}
        aria-label={CHAT_WIDGET.launcherLabel}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z" />
        </svg>
        <span className={s.launcherLabel}>{CHAT_WIDGET.launcherLabel}</span>
      </button>
    </div>
  );
}
